/*====================================
    退款 相關功能Factory

    Author : Gray
    最後更新時間 : 2017 / 06 / 15
====================================*/

window.InifECShared.factory("RefundrecService", ['$q', '$http', 'Upload', '$rootScope', function($q, $http, Upload, $rootScope) {

	var factory = this;

    // --------------------------------
    // 送印前退款／取消訂單
    // --------------------------------
    var discardPaidOrder = function(orderid, accountName, bankCode, atmAccount, file, bankBranch) {

        var defer = $q.defer();
        
        if(file) {
            Upload.upload({
                url: SECURE_INIFEC_URL + "/RefundrecAction.do",
                fields: {
                    op: "discardPaidOrder",
                    orderid: orderid,
                    accountName: accountName,
                    bankCode: bankCode,
                    atmAccount: atmAccount,
                    bankBranch: bankBranch,
                },
                file: file,
                fileFormDataName: 'file',
                withCredentials: true
            }).progress(function(evt) {
                var percent = parseInt(100.0 * evt.loaded / evt.total);
                file.progress = percent;
            }).success(function(data, status, headers, config) {
                if (data.error) {
                    if(data && data.error && data.error.code == 'error.privilege.noLogin') {
                        $rootScope.$broadcast('OPEN_LOGOUT_ALERT_MODAL');
                    }
                    defer.reject(data.error);
                } else {
                    defer.resolve(data);
                }
            }).error(function(data, status, headers, config) {
                defer.reject(data);
                console.error("[InifEC Error] : RefundrecService.discardPaidOrder request error.");
                console.error("status : " + status);
            });
        } else {
            $http({
                url: SECURE_INIFEC_URL + "/RefundrecAction.do",
                method: "POST",
                data: $.param({
                    op: "discardPaidOrder",
                    orderid: orderid,
                    accountName: accountName,
                    bankCode: bankCode,
                    atmAccount: atmAccount,
                    bankBranch: bankBranch,
                }),
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                withCredentials: true
            }).success(function(data) {
                if (data.error) {
                    if(data && data.error && data.error.code == 'error.privilege.noLogin') {
                        $rootScope.$broadcast('OPEN_LOGOUT_ALERT_MODAL');
                    }
                    defer.reject(data.error);
                } else {
                    defer.resolve(data);
                }
            }).error(function(data, status, headers, config) {
                defer.reject(data);
                console.error("[InifEC Error] : RefundrecService.discardPaidOrder request error.");
                console.error("status : " + status);
            });
        }

        return defer.promise;
    }

    // 送印前退款／取消訂單
    factory.discardPaidOrder = discardPaidOrder;

    return factory;
}]);
